import React, {useState} from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Link } from 'react-router-dom';
import styles from './Back2TopButton.module.scss'
import {windowScroll} from '../../../utils/eventHandling'

function BackToTopButton() {

    const [visible, setVisible] = useState(false)
    const toggleVisible = () => {
        setVisible(windowScroll())
    };
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' 
            /* you can also use 'auto' behaviour in place of 'smooth' */
        });
    };

    window.addEventListener('scroll', toggleVisible);
    const styleClass = `${styles['back-to-top']} active`;
    return (
        <>
            {visible &&
                (<Link to="/#introduction" className={styleClass}>
                    <KeyboardArrowUpIcon onClick={scrollToTop} />
                </Link>)
            }
        </>
    )
}


export default BackToTopButton;